import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import services from 'core/services';
import { PureComponent, Serialize } from 'core/components';
import { withLocale } from 'core/decorators';
import { Row, Link, Stepper, Col, Icon } from 'core/components/Framework7';
import { addToCart, deleteItem, changeCountItem } from 'content/pages/Cart/Module';

import classes from './styles.module.css';

const Price = Serialize.Price

class Favorite extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  static get defaultProps() {
    return {
      items: []
    }
  }

  get initialValue() {
    return this.parseFavoriteItems()
  }

  /**
   * parse items for show in category
   * @param {Array} items 
   */
  parseFavoriteItems() {
    const { items } = this.props;

    if (!items) return []

    return items.map(item => {
      return this.parseFavoriteItem(item)
    })
  }

  /**
   * parse item of category
   * @param {Object} item 
   */
  parseFavoriteItem(item) {
    return {
      id: item.id,
      alt: item.product ? item.product.cover ? item.product.cover.title : null : null,
      url: item.product && item.product.cover && services.utils.url.image(item.product.cover, 4),
      name: item.product ? item.product.name : null,
      link: item.id,
      childrenType: item.childrenType,
      currentPrice: item.product ? item.product.currentPrice : null,
      currentDiscount: item.product ? item.product.currentDiscount : null,
      count: item.count,
      productId: item.product ? item.product.id : null
    }
  }

  changeSteper(item, value) {
    const params = {
      store: 2,
      errorHandler: true
    }

    const model = {
      count: value,
      orderId: null,
      productId: item.productId
    }

    const id = item.id

    if (value === 1) return this.props.addToCart(model, params)

    if (value === 0) return this.props.deleteItem(id, { store: 2 })

    return this.props.changeCountItem(id, { count: value }, params)
  }

  deleteCartItem(item) {
    const id = item.id
    return this.props.deleteItem(id, { store: 2 })
  }

  renderFavoriteItems() {
    const items = this.initialValue

    return items.map(item => {
      return this.renderFavoriteItem(item)
    })
  }

  renderFavoriteItem(item) {
    return (
      <Col key={item.id} width="100" className={classes.productCol}>
        <Row className={classes.topRowProduct}>
          <Col width="30" className={classes.productImage}>
            <Link href={`/product/${item.productId}`}>
              <img src={item.url} alt="product" />
            </Link>
          </Col>
          <Col width="70">
            <p className={classes.titleProduct}>{item.name}</p>
            <p className={classes.discountPrice}><Price price={item.currentPrice} /></p>
          </Col>
        </Row>
        <Row>
          <Col width="10" className={classes.trash} onClick={(e) => this.deleteCartItem(item)} >
            <Icon material="trashcan" />
          </Col>
          <Col width="55"></Col>
          <Col width="35">
            <Stepper className={classes.steper} input={false} value={item.count} onStepperChange={(e) => this.changeSteper(item, e)} raised color="gray"></Stepper>
          </Col>
        </Row>
      </Col>
    )
  }

  render() {
    return (
      <React.Fragment>
        <Row className={classes.productRow}>
          {this.renderFavoriteItems()}
        </Row>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    cart: state.Cart.cart
  }),
  {
    addToCart,
    changeCountItem,
    deleteItem
  }
)(withLocale('favorite')(autobind(Favorite)))
